import React from 'react';
import PaymentTransactionTableConfig from './PaymentTransactionTableConfig';
import LightButton from '../../components/button/LightButton';

const columns = [
  {
    field: 'creationDate',
    label: 'Data dodania',
    sort: 'asc',
    type: 'badge',
    width: 180,
  },
  ...PaymentTransactionTableConfig,
  {
    field: 'reservationId',
    label: 'Rezerwacja',
    type: 'custom',
    exportValue: (row) => row.reservationId,
    custom: function (column, row, navigate) {
      return (
        <div className={'d-flex'}>
          <LightButton
            onClick={() => {
              navigate('/reservation/' + row.reservationId);
            }}
            size={'sm'}
          >
            Szczegóły
          </LightButton>
        </div>
      );
    },
    width: 300,
  },
];

export default columns;
